"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dateArrayToAge;
function dateArrayToAge(date) {
  // check the date is valid
  if (!Array.isArray(date) || date.length !== 3 || date.some(function (v) {
    return !v || isNaN(v);
  }) || !~~date[0] || !~~date[1] || !~~date[2]) {
    return false;
  }

  // get the date parts of the DOB
  var dob = {};
  dob.day = ~~date[0];
  dob.month = ~~date[1];
  dob.year = ~~date[2];

  // get the date parts of today
  var dateObj = new Date();
  var today = {};
  today.day = dateObj.getDate();
  today.month = dateObj.getMonth() + 1;
  today.year = dateObj.getFullYear();

  // get the year difference
  var yearsDiff = today.year - dob.year;

  // catch 0yr olds & future beings
  if (!yearsDiff) {
    return false;
  }

  // deduct a year if this year's birthday is before today
  if (today.month < dob.month) {
    yearsDiff -= 1;
  } else if (today.month === dob.month && today.day < dob.day) {
    yearsDiff -= 1;
  }
  return yearsDiff;
}